import { render, staticRenderFns } from "./orderAlipay.vue?vue&type=template&id=3c1a3ed5&"
import script from "./orderAlipay.vue?vue&type=script&lang=js&"
export * from "./orderAlipay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports